import * as React from "react";
import { Tooltip } from "@/components/ui";
import { cn } from "@/lib/utils";
import { formatCount } from "../performance";

export interface StatTileProps {
  label: string;
  value: number;
  sub?: string;
  /** Shown on hovering the sub line, e.g. what an average is taken over. */
  subTooltip?: string;
  /** Sits right of the value. */
  aside?: React.ReactNode;
  /** A second line under the value. */
  footer?: React.ReactNode;
  className?: string;
}

export function StatTile({ label, value, sub, subTooltip, aside, footer, className }: StatTileProps): JSX.Element {
  const subLine = sub && <span className="whitespace-nowrap text-[11px] text-slate-500 tabular-nums">{sub}</span>;
  return (
    <div className={cn("rounded-xl border border-slate-200 bg-slate-50/60 p-3", className)} data-testid="stat-tile">
      <div className="text-[11px] uppercase font-bold text-slate-500">{label}</div>
      <div className="flex flex-wrap items-baseline gap-x-1.5">
        <span className="text-xl font-bold text-slate-800 tabular-nums">{formatCount(value)}</span>
        {subLine && subTooltip ? (
          <Tooltip>
            <Tooltip.Trigger render={<span className="cursor-help" />}>{subLine}</Tooltip.Trigger>
            <Tooltip.Content>{subTooltip}</Tooltip.Content>
          </Tooltip>
        ) : (
          subLine
        )}
        {aside && <div className="ml-auto self-center">{aside}</div>}
      </div>
      {footer && <div className="mt-0.5 text-[11px] text-slate-500 tabular-nums">{footer}</div>}
    </div>
  );
}
